import { render, staticRenderFns } from "./ParcelsTable.vue?vue&type=template&id=6f199b43&scoped=true"
import script from "./ParcelsTable.vue?vue&type=script&lang=js"
export * from "./ParcelsTable.vue?vue&type=script&lang=js"
import style0 from "./ParcelsTable.vue?vue&type=style&index=0&id=6f199b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f199b43",
  null
  
)

export default component.exports